import { getTrialAvailability, getLeaseManager } from '@/license';
import store from '@/store';
import { USER_LICENSE_CHECK_STARTED, USER_LICENSE_CHECK_COMPLETED } from '@/store/mutation-types';
import { LeaseState } from '@common/license/types';
import { NavigationGuard } from 'vue-router';

const getUserTrialAvailability = async () => {
  const data = await getTrialAvailability();

  if (data) {
    const canHaveTrial = Boolean(data.canTrail);

    store.commit('user/USER_CAN_HAVE_TRIAL', canHaveTrial);
  }
};

const leaseManager = getLeaseManager(store);

export const licenseGuard: NavigationGuard = async (_to, _from, next) => {
  store.commit(`user/${USER_LICENSE_CHECK_STARTED}`);

  await Promise.all([
    getUserTrialAvailability().catch(() => {
      // Ignore error. We just assume the user has no trial option
    }),
    leaseManager.getLease(),
  ]);

  store.commit(`user/${USER_LICENSE_CHECK_COMPLETED}`);

  if (store.state.user.authStatus === 'NEW') {
    store.dispatch('onboarding/show', {});
  } else if (
    store.state.user.leaseState !== LeaseState.Ok &&
    store.state.user.leaseState !== LeaseState.ServerUnavailable &&
    store.state.user.authStatus === 'UPDATED'
  ) {
    store.dispatch('modal/show', {
      type: 'LicenseUpgradeCard',
      payload: {
        canHaveTrial: store.state.user.canHaveTrial,
      },
    });
  } else if (
    store.state.user.leaseState === LeaseState.Ok &&
    Number.isInteger(store.getters['user/remainingTrialDays'])
  ) {
    store.dispatch('modal/show', {
      type: 'LicenseTrialStartupCard',
      payload: {
        daysLeft: store.getters['user/remainingTrialDays'],
      },
    });
  } else if (store.state.user.leaseState === LeaseState.NoFreeSeats) {
    store.dispatch('modal/show', {
      type: 'LicenseNoSeatCard',
    });
  }

  next();
};
